import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {ToastrService} from "ngx-toastr";
import {DeviceService} from "../../../services/device/device.service";
import {TranslateService} from "@ngx-translate/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {faExchangeAlt} from "@fortawesome/free-solid-svg-icons";
import {environment} from "../../../../../environments/environment";
import {StatesService} from "../../../services/state/states.service";
import {LevelService} from "../../../services/level/level.service";
import {AuthenticationService} from "../../../services/authentication/authentication.service";

@Component({
    selector: 'app-device-batch-action',
    templateUrl: './device-batch-action.component.html',
    styleUrls: ['./device-batch-action.component.css']
})
export class DeviceBatchActionComponent implements OnInit {

    public displayedColumns: string[] = ['device_type', 'device', 'action'];
    public devices: MatTableDataSource<any>;
    public pageSizeOptions = environment.pageSizeOptions;
    public pageSize = environment.pageSize;
    public showSpinner: boolean = false;
    public faExchangeAlt = faExchangeAlt;
    public levelsDropList: any[] = [];
    public levelId;
    public currentLevelName: string = "";

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Input('devicesList') devicesList: any[] = [];

    constructor(private toastr: ToastrService,
                public activeModal: NgbActiveModal,
                private translate: TranslateService,
                private deviceService: DeviceService,
                public statesService: StatesService,
                private levelService: LevelService,
                public authenticationService: AuthenticationService) {
    }

    ngOnInit() {
        this.levelId = this.statesService.stateLevel;
        if (this.authenticationService.getStoredUser()) {
            this.showSpinner = true;
            this.levelService.getLevels(true).subscribe((data: any) => {
                this.levelsDropList = data;
                this.showSpinner = false;
            });

        }
        this.devices = new MatTableDataSource(this.devicesList);
        this.devices.filter = null;
        this.devices.sort = this.sort;
        this.devices.paginator = this.paginator;
        this.currentLevelName = this.getCurrentLevelName();
    }

    getCurrentLevelName(): string {
        let name: string = ""
        this.levelsDropList.forEach((level: any) => {
            if (level.id === this.statesService.stateLevel) {
                name = level.name;
            }
        });
        return name;
    }

    removeDevice(deviceId : number){

        this.devices.data =   this.devices.data.filter(function (value) {
            return value.id !== deviceId;
        });


    }

    patchDeviceCollection() {
        if (this.devices.data.length > 0) {
            this.showSpinner = true;
            let listDevice = [];
            this.devices.data.forEach((d) => {
                listDevice.push(d.id);
            });
            this.deviceService.patchDevicesCollection(this.levelId, listDevice)
                .subscribe(
                    (data: any) => {
                        this.devices.data = [];
                        this.toastr.success(this.translate.instant('DEVICE_MODIFIED'), this.translate.instant('SUCCESS'));
                        this.statesService.reloadListDevices.next();
                        this.showSpinner = false;
                    },
                    error2 => {
                        this.showSpinner = false;
                    }
                )
        } else {
            this.activeModal.dismiss();
        }
    }

}
